import root from "react-shadow";

export const ShadowDom = ({ html }) => {
  return (
    <root.div style={{ maxWidth: "100%" }}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </root.div>
  );
};
